import { VERTICAL_ASPECT_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const instagramPage: TemplatePage = {
  header: {
    color: '#CCADE6',
    icon: 'images/video-templates/instagram-video.jpg',
    title: 'Instagram Video Templates Collection',
    title_meta: '400+ Easy-to-Edit Instagram Video Templates',
    description_meta:
      'Amaze your social media followers with Wave.video’s 400+ customizable Instagram video templates.',
    description:
      'Amaze your social media followers with 400+ beautiful, customizable Instagram video templates. Curated by ' +
      'professional designers, these templates will help you easily create scroll-stopping Instagram videos for any industry.'
  },
  footer: {
    category: 'Instagram',
    description:
      'With Wave.video’s collection of easy-to-edit Instagram video templates, there is no need to be a professional ' +
      'designer to create eye-stopping videos for social media. All you need to do is pick a template of your liking, ' +
      'customize it to match your brand, and download the resulting video. Fast and simple!'
  },
  content: [
    {
      type: 'templates',
      title: 'Instagram Video',
      search: {
        aspects: VERTICAL_ASPECT_STRING
      }
    },
    {
      type: 'stocks',
      title: 'instagram',
      search: { name: 'instagram' }
    },
    { type: 'calendar' }
  ]
};

export default instagramPage;
